import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {UiAssignmentsComponent} from "./ui-assignments.component";
import {UiAppNoDataModule} from "../ui-app-no-data/ui-app-no-data.module";
import {RouterModule} from "@angular/router";
import {PipesModule} from "../../app.pipes.module";
import {UiTooltipModule} from "../ui-tooltip/ui-tooltip.module";
import { UiAssignmentModule } from "../ui-assignment/ui-assignment.module";



@NgModule({
  declarations: [UiAssignmentsComponent],
  exports: [UiAssignmentsComponent],
  imports: [
    CommonModule,
    UiAppNoDataModule,
    RouterModule,
    PipesModule,
    UiTooltipModule,
    UiAssignmentModule
  ]
})
export class UiAssignmentsModule { }
